import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Icon, Modal } from "semantic-ui-react";
import { deleteSport } from "../../store/actions/athleteActions";
import EditSport from "./EditSport";
const SportDetails = (props) => {
  const [sportOptions, setSportOptions] = useState([]);
  const [positions, setPositions] = useState([]);
  const [games, setGames] = useState([]);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [key, setKey] = useState();
  const [sportValue, setSportValue] = useState();
  const sports = props.sports;
  const [positionOptions, setPositionOptions] = useState(null);
  const [confirmationPopup, setConfirmationPopup] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (sports) {
      setGames(sports[0]);
      setPositionOptions(sports[1]);
    }
  }, [sports]);

  useEffect(() => {
    let storingObject = Object.keys(games).filter((index) => index !== "id");
    storingObject = storingObject.sort();
    const object = storingObject.map((keyName, i) => {
      return {
        key: i,
        value: games[keyName],
        sportKey: keyName,
        sportValue: games[keyName],
      };
    });
    setSportOptions(object);
    if (value && games) {
      const positionObject = positionOptions[value];
      const positions = Object.keys(positionObject).map((key, index) => {
        return {
          key: index,
          position: positionObject[key],
        };
      });
      setPositions(positions);
    }
  }, [games, value]);

  const EditSportOpen = (val, key, sportValue) => {
    setOpen(true);
    setValue(val);
    setKey(key);
    setSportValue(sportValue);
  };
  const EditSportClose = () => {
    setOpen(false);
    props.close();
  };

  const confirmationPopupHandler = (deleteID) => {
    setConfirmationPopup(deleteID);
  };
  const handleDelete = () => {
    dispatch(deleteSport(confirmationPopup.toLowerCase(), confirmationPopup));
    setConfirmationPopup(false);
  };
  return (
    <>
      <div className="AdminFormContainer">
        <div className="edit-sport-section">
          <div className="AdminFormPersonalInfoContainer">
            <h3 className="text-center">View Sports & Postions</h3>
          </div>
          <ul>
            {sportOptions &&
              sportOptions.map((sport) => {
                return (
                  <>
                    <li key={sport.key}>
                      <div className="full-sport">
                        <div className="one">
                          <h3>{sport.key + 1}</h3>
                        </div>
                        <div
                          className="two"
                          onClick={() =>
                            EditSportOpen(
                              sport.value,
                              sport.sportKey,
                              sport.sportValue
                            )
                          }
                          key={sport.key}
                        >
                          <h3>{sport.value}</h3>
                        </div>
                        <div className="three">
                          <Button
                            circular
                            icon
                            color="red"
                            name="editedButton"
                            onClick={() =>
                              confirmationPopupHandler(sport.value)
                            }
                          >
                            <Icon name="trash" />
                          </Button>
                        </div>
                      </div>
                    </li>
                    {confirmationPopup && (
                      <Modal className="delete-popup" open={confirmationPopup}>
                        <Modal.Content>
                          <p className="p1">
                            Are you sure want to delete the '{confirmationPopup}
                            '?
                          </p>
                          <p className="p2">
                            If you delete then all sport related position will
                            deleted automatically
                          </p>
                          <p className="p2">this process cannot be undone.</p>
                          <div className="delete-modal-footer">
                            <Button
                              name="closeButton"
                              content="Cancel"
                              onClick={() => setConfirmationPopup(false)}
                            />
                            <Button
                              color="red"
                              name="saveButton"
                              content="Delete"
                              onClick={handleDelete}
                            />
                          </div>
                        </Modal.Content>
                      </Modal>
                    )}
                  </>
                );
              })}
          </ul>
        </div>
      </div>
      <EditSport
        editSport={open}
        close={EditSportClose}
        value={value}
        positions={positions}
        sportKey={key}
        sportValue={sportValue}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    sports: state.firestore.ordered.sports,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "sports",
    },
  ])
)(SportDetails);
